/* eslint-disable */

import React from "react";
import Grid from "material-ui/Grid";
import Card, { CardHeader, CardContent } from "material-ui/Card";
import { assets } from "../../../assets";
import { GreenElectricityCardContent } from "./GreenElectricityCardContent";

export class GreenElectricityCard extends React.Component {
  render() {
    const {
      classes,
      t,
      energyInWhForRange,
      energyInWhYTD,
      loading,
      currentAssetConsuming,
      dateRangeText
    } = this.props;
    return (
      <Grid item xs={12} sm={3}>
        <Card className={classes.card} style={{ minHeight: 224 }}>
          <CardHeader
            avatar={<img src={assets.icons.boltIcon} style={{ maxHeight: 20 }} />}
            title={t("Green electricity")}
          />
          <CardContent>
            <GreenElectricityCardContent
              classes={classes}
              t={t}
              energyInWhForRange={energyInWhForRange}
              energyInWhYTD={energyInWhYTD}
              loading={loading}
              currentAssetConsuming={currentAssetConsuming}
              dateRangeText={dateRangeText}
            />
          </CardContent>
        </Card>
      </Grid>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/EquivalentToCards/GreenElectricity/GreenElectricityCard.js